<ng-template [ngIf]="show">
  <a *ngIf="!isSkipped && !confirm" (click)="skip()">{{ question.skippable }}</a>
  <a class="confirmation" *ngIf="!isSkipped && confirm" (click)="skip()">{{ question.skipConfirmation }}</a>
  <p *ngIf="showSkipped">Skipped.</p>
</ng-template>
